module.exports = __webpack_public_path__ + "static/media/three.66906f1f.jpg";